import { Suspense, useEffect, createContext } from 'react';
import { hot } from 'react-hot-loader';
import AOS from 'aos';
import { createWeb3ReactRoot, Web3ReactProvider } from '@web3-react/core';
import { ToastContainer } from 'react-toastify';
import { Provider as StoreProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { I18nextProvider } from 'react-i18next';
import { ModalProvider } from 'react-simple-modal-provider';
import { HashRouter as Router } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';
import configureStore from './store';
import * as A from './store/actions';
import { api } from './store/configureStore';
import { NetworkContextName } from './constants/index';
import getLibrary from './utils/getLibrary';
import i18n from './i18n';

//import WalletConnectModal from './modal/WalletConnectModal';
//import WalletAccountModal from './modal/WalletAccountModal';
//import RefLinkQrCodeModal from './modal/RefLinkQrCodeModal';
import AlertModal from './modal/AlertModal';
import VideoModal from './modal/VideoModal';
//import MintModal from './modal/MintModal';
//import ChangeNameModal from './modal/ChangeNameModal';

import { fbqId } from './configs';


const modals = [
  //MintModal, 
  //WalletConnectModal, WalletAccountModal, ChangeNameModal, 
  AlertModal, VideoModal
];

const Web3ProviderNetwork = createWeb3ReactRoot(NetworkContextName);

const { store, persistor } = configureStore(window?.__PRELOADED_STATE__);
delete window?.__PRELOADED_STATE__;



function Providers({ children }: any) {
  useEffect(() => {
    // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
    //const advancedMatching = {};
    /*const options = {
      // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
      autoConfig: true,
      // enable logs
      debug: false,
    };*/
    ReactPixel.init(fbqId);
    // For tracking page view
    ReactPixel.pageView();

    AOS.init({
      //duration: 2000
    });

    api.getAllMedatada().then((medatada: any) => {
      store.dispatch(A.nft.setMetadata(medatada));
    }).catch(() => null);
  }, []);

  return (
    <Suspense fallback={null}>
      <div id="app">
        <div className="line"></div>
        <Web3ReactProvider getLibrary={getLibrary}>
          <Web3ProviderNetwork getLibrary={getLibrary}>
            <StoreProvider store={store}>
              <PersistGate loading={null} persistor={persistor}>
                <I18nextProvider i18n={i18n}>
                  <Router>
                    <ModalProvider value={modals}>
                      {children}
                    </ModalProvider>
                  </Router>
                </I18nextProvider>
              </PersistGate>
            </StoreProvider>
          </Web3ProviderNetwork>
        </Web3ReactProvider>

        <ToastContainer
          position='top-right'
          autoClose={2500}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          style={{ zIndex: 10000, width: '350px', }}
          theme='dark'
        />
      </div>
    </Suspense>
  );
}

export default hot(module)(Providers);
